export const notFlag = "~";
